import { NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';
import { InlineSpinnerComponent } from '../inline-spinner/inline-spinner.component';

/**
 * Small accent spinner for the suffix of a search input or loose control
 * (`<gd-input-busy matSuffix [busy]="busy$ | async" />`). The input stays
 * enabled; the host only announces the status for assistive tech. Drive `busy`
 * with `showAfterDelay` / `BusyTracker.indicator$()` so it does not flash.
 */
@Component({
  selector: 'gd-input-busy',
  standalone: true,
  imports: [NgIf, InlineSpinnerComponent],
  template: `
    <gd-inline-spinner *ngIf="busy" size="sm" tone="accent"></gd-inline-spinner>
    <span class="cdk-visually-hidden" role="status" aria-live="polite">{{
      busy ? label : ''
    }}</span>
  `,
  styles: [
    `
      :host {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: 16px;
        margin-right: 8px;
      }

      :host(.gd-input-busy--idle) {
        display: none;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputBusyIndicatorComponent {
  @Input() busy: boolean | null = false;
  @HostBinding('class.gd-input-busy--idle') get idle(): boolean {
    return !this.busy;
  }
  /** Text announced to assistive tech while busy. */
  @Input() label = 'Buscando...';
}
